import React from "react";
import cs from "classnames";
import { LabelWithInformationBox } from "../LabelWithInformationBox/LabelWithInformationBox";
import { Icon } from "../Icon/Icon";

import "./RadioButton.scss";

interface Props {
  title: string;
  checked: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  value: string;
  name: string;
  className?: string;
  hideTitle?: boolean;
}

export const RadioButton = ({
  title,
  checked,
  onChange,
  value,
  name,
  className,
  hideTitle = false,
}: Props) => {
  return (
    <div className={cs("RadioButton flex-a-center", className)}>
      {!hideTitle && <LabelWithInformationBox title={title} className="pr-2" />}

      <div className="RadioButton__input">
        <input
          id={value}
          name={name}
          type="radio"
          checked={checked}
          onChange={onChange}
          value={value}
        />

        <Icon icon={checked ? "radio-checked-default" : "radio"} />
      </div>
    </div>
  );
};
